<template>
    <div class="aba-insumos">
        <div class="vertical-flow">
            <div class="columns">
                <!-- CAIXA DE BUSCA -->
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-4'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-produto"
                    />
                </div>

                <div
                    class="column situacao-select"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-2'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <vss-select
                        ref="situacaoInput"
                        title="situacao"
                        :options="situacoes"
                        :mlLabels="true"
                        @input="onSituacaoChanged"
                        v-model="situacao"
                        :height="40"
                        :clearable="true"
                    />
                </div>
                <!-- BOTÃO DE VÍNCULO -->
                <div class="column is-3" v-if="permissaoVincular">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        v-if="!assNivelTecnologicoProdutoIntegracao"
                        @click="showModal = !showModal"
                    >
                        {{ $t('vincular-insumo') }}
                    </button>
                </div>
                <!-- Botao vai para a tela de cadastro de produto, e a função para
        voltar para a tela atual está na OcorrenciaManage e Geral de produto -->
                <div class="column is-3" v-if="permissaoCadastrar">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: 'ven-produto-new',
                                query: { tela: 'agro-niveltecnologico-edit', id: $route.params.id },
                            })
                        "
                    >
                        {{ $t('adicionar-produto') }}
                    </button>
                </div>
            </div>
            <!-- LISTAGEM -->
            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assNivelTecnologicoProduto"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row[f.key] == 1 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row[f.key] == 1 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <span v-if="permissao.update && !assNivelTecnologicoProdutoIntegracao">
                                <b-button
                                    class="action-button"
                                    :type="props.row['situacao'] == 1 ? 'is-danger' : 'is-success'"
                                    :icon-right="props.row['situacao'] == 1 ? 'delete' : 'check'"
                                    @click="promptChangeSituacao(props.row)"
                                    v-tippy
                                    :title="
                                        $t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')
                                    "
                                />
                            </span>
                        </div>
                        <div v-else-if="f.key == 'descricao'">
                            <a
                                v-if="permissaoEditarVinculo"
                                @click.prevent="openModalEdit(props.row)"
                            >
                                {{ props.row[f.key] }}
                            </a>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModal">
                <div class="bg">
                    <ProdutoModal
                        :idagroniveltecnologico="idagroniveltecnologico"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>

            <b-modal :active.sync="showEditModal">
                <div class="bg">
                    <InsumoModal :assToEditId="insumoToEdit.id" @fecharModal="fecharModalEdit" />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AgroAssNivelTecnologicoProdutoService from '@/services/agro/nivel-tecnologico/AgroAssNivelTecnologicoProdutoService';
import ProdutoModal from '@/components/agro/niveltecnologico/modal/ProdutoModal';
import InsumoModal from '@/components/agro/niveltecnologico/modal/InsumoManageModal';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

/* @71224 - Cadastro de nível tecnológico - Aba insumos */
export default {
    components: {
        ContainerLoader,
        ProdutoModal,
        InsumoModal,
    },
    props: {
        idagroniveltecnologico: 0,
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes(
                'AGRO_NIVELTECNOLOGICO'
            ),
            assNivelTecnologicoProdutoIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'AGRO_ASSNIVELTECNOLOGICOPRODUTO'
            ),
            produtoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('PRODUTO'),
            assNivelTecnologicoProduto: [],
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                { key: 'familia', width: null, sortable: true, sortFn: null },
                { key: 'consumoalqueire', width: 100, sortable: true, sortFn: null },
                { key: 'consumohectare', width: 100, sortable: true, sortFn: null },
                { key: 'situacao', width: 100, sortable: true, sortFn: null },
                { key: 'excluir', width: null, sortable: false, sortFn: null },
            ],
            service: new AgroAssNivelTecnologicoProdutoService(this.$http, this.$router),
            permissao: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacao: { id: 2, label: 'todos' },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'produto',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModal: false,
            showEditModal: false,
            permissaoCadastroProduto: false,
            insumoToEdit: {},

            //permissoes relativas à exibição dos botões
            permissaoVincular: false,
            permissaoCadastrar: false,
            permissaoEditarVinculo: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess(
            'agro',
            'agro-cadastros',
            'agro-niveltecnologico'
        );

        //verificar permissão da página de produto para controlar o botão de adicionar
        this.permissaoProduto = this.hasPermissionAccess('vendas', 'produtos', 'ven-produto');

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'agro-niveltecnologico' },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }

        // retirar && false quando tiver página de produto
        this.permissaoVincular =
            this.permissao.create && !this.assNivelTecnologicoProdutoIntegracao;
        this.permissaoCadastrar = this.permissaoProduto.create && !this.produtoIntegracao && false;
        this.permissaoEditarVinculo =
            this.permissao.update && !this.assNivelTecnologicoProdutoIntegracao;
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.idagroniveltecnologico,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.assNivelTecnologicoProduto = value;
                    this.isEmpty = this.assNivelTecnologicoProduto.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar as tabelas de produto.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    id: m.idagroassniveltecnologicoproduto,
                    codigo: m.produto.idprodutoerp,
                    idagroniveltecnologico: m.idagroniveltecnologico,
                    idproduto: m.produto.idproduto,
                    descricao: m.produto.descricao,
                    familia:
                        m.produto.produtoFamilia.descricao == null
                            ? m.produto.produtoFamilia.descricao
                            : '---',
                    consumoalqueire: m.consumoalqueire,
                    consumohectare: m.consumohectare,
                    excluir: 'excluir',
                    situacao: m.situacao,
                };
            });
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        removePrompt() {
            this.delete = null;
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? 'msg-sucesso-ao-reativar-associacao-produto'
                    : 'msg-sucesso-ao-desativar-associacao-produto';

            let tempAssNivelTecnologicoProduto = {
                idagroassniveltecnologicoproduto: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };
            this.isLoading = true;

            this.service
                .updateSituacao(tempAssNivelTecnologicoProduto)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? 'msg-sucesso-ao-reativar-associacao-produto'
                                : 'msg-sucesso-ao-desativar-associacao-produto';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        openModalEdit(reg) {
            this.showEditModal = true;
            this.insumoToEdit = reg;
        },
        fecharModal() {
            this.showModal = false;
            this.carregarDados();
        },
        fecharModalEdit() {
            this.showEditModal = false;
            this.carregarDados();
        },
        cadastrado() {
            this.carregarDados();
            this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-insumos {
    height: 100%;

    .situacao-select {
        div {
            height: 40px;
        }
    }

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }

        .situacao-select {
            width: 100%;
            padding-bottom: 0.8rem;
        }

        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
